export default __webpack_public_path__ + "static/media/warning_icon.b201c4a9.svg";